enum DistributorType {
  Physical = "PHYSICAL",
  Online = "ONLINE",
}

export default DistributorType;
